import React from 'react';
import {Grid, Segment, Image, Divider, Button, Icon} from 'semantic-ui-react';
import './Description.css';

export default (props) => {
    var {header, task_info_header, task_info_paragraph, challengeImage, videoUrl, watchVideoLabel, description_header, description_paragraph, task_header, task_paragraph, requirements_header, requirements_paragraph, paragraph} = props;
    return  <section id="details"><Grid>
        <Grid.Row>
            <Grid.Column textAlign="justified">
                <article>
                    {typeof header !== 'undefined'?
                                <header>{header}</header>
                        : null }
                    {typeof challengeImage !== 'undefined'?

                        <Segment basic textAlign='center'>
                                <Image draggable="false" src={challengeImage} />
                        </Segment> : null }
                    {typeof videoUrl !== 'undefined' && typeof watchVideoLabel !== 'undefined'?
                        <Segment basic clearing>
                            <Button style={{borderRadius: 0}} negative onClick={() => window.open(videoUrl)}>
                                <Icon name="video" />
                                {watchVideoLabel}
                            </Button>
                        </Segment> : null }
                    {typeof paragraph !== 'undefined'?
                        <div>
                        {paragraph.map((p, index) => {
                            if (index < 2)
                            {
                                return <p>{p}</p>
                            } else {
                                return <li>{p}</li>
                            }
                        })}</div>
                        : null }
                    {(typeof description_header !== 'undefined' && description_paragraph !== 'undefined')?
                        <div><header>{description_header}</header>
                        {description_paragraph.map(paragraph => (
                            <li>{paragraph}</li>
                        ))}<Divider /></div>
                        : null }
                    {(typeof task_header !== 'undefined' && task_paragraph !== 'undefined')?
                        <div><header>{task_header}</header>
                        {task_paragraph.map(paragraph => (
                            <li>{paragraph}</li>
                        ))}</div>
                        : null }
                    {(typeof requirements_header !== 'undefined' && requirements_paragraph !== 'undefined')?
                        <div><header>{requirements_header}</header>
                        {requirements_paragraph.map(paragraph => (
                            <li>{paragraph}</li>
                        ))}</div>
                        : null }
                    {(typeof task_info_header !== 'undefined' && task_info_paragraph !== 'undefined' )?
                        <div><header>{task_info_header}</header>
                        {task_info_paragraph.map(task_info => (
                            <li>{task_info}</li>
                        ))}
                        </div>
                        : null }
                 </article>
            </Grid.Column>
        </Grid.Row>
    </Grid>
</section>
}


// WEBPACK FOOTER //
// ./src/components/description/DescriptionContainer.jsx